<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="缓存名称" name="cache_name"></c-form-item>
					<c-form-item type="input" label="缓存key" name="cache_key"></c-form-item>
				</c-form>
			</m-search>

			<c-table ref="table" code="cache_info_list">

				<c-table-column
					label="缓存名称"
					name="cache_name"
					width="200"
				>
				</c-table-column>

				<c-table-column
						label="缓存key"
						name="cache_key"
						width="400"
				>
				</c-table-column>

				<c-table-column
					label="缓存周期（小时）"
					name="cache_cycle"
					width="130"
				>
				</c-table-column>
				
				<c-table-column
					label="最近更新日期"
					name="update_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					label="最近更新人"
					name="update_user_realname"
					width="110"
				>
				</c-table-column>
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="110"
				>
					<template v-slot="{data}">
							<c-table-button power="b_cache_info_check" @click="check(data)">检测</c-table-button>
							<c-table-button power="b_cache_info_clear" @click="clear(data)">清除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_cache_info',
		
		data() {
			return {
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},

		methods: {

			searchHandle(data) {
				this.$refs.table.load({
					url: '/cache/list',
					data
				});
			},

			check(val) {
				this.request({
					url: '/cache/check',
					data: {cache_key:val.cache_key},
					loading: true,
					success: data => {
						this.$message({
							text: '当前【'+val.cache_name+'】存在缓存数量为：' + data,
							icon: 'success'
						});
					}
				});
			},

			clear(val) {
				this.$confirm({
					text: '确定要清除所有【'+val.cache_name+'】缓存吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/cache/clear',
							data: {ids:[val.id]},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>